import { render, staticRenderFns } from "./SaveSearchContainer.vue?vue&type=template&id=bf3abaca&scoped=true"
import script from "./SaveSearchContainer.vue?vue&type=script&lang=js"
export * from "./SaveSearchContainer.vue?vue&type=script&lang=js"
import style0 from "./SaveSearchContainer.vue?vue&type=style&index=0&id=bf3abaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3abaca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDialog,VListItem,VTextField})
